module.exports = __webpack_public_path__ + "media/images/redesign-images/home/carousel/business-mobile-4bb240d1431dd770799b2709679b38bb.jpg";